import type { Communication } from "../types";

type Props = {
  communications: Communication[];
};

export function CommThread({ communications }: Props) {
  if (communications.length === 0) {
    return <p className="text-xs text-tribal-muted italic">No messages yet.</p>;
  }

  return (
    <div className="space-y-2 max-h-60 overflow-y-auto">
      {communications.map((comm) => (
        <div
          key={comm.id}
          className={`rounded-lg p-2 text-xs ${
            comm.channel === "note"
              ? "bg-blue-500/10 border border-blue-500/20 ml-2 mr-2"
              : comm.channel === "phone"
                ? "bg-amber-500/10 border border-amber-500/20 ml-2 mr-2"
                : comm.direction === "outbound"
                  ? "bg-tribal-red/10 border border-tribal-red/20 ml-4"
                  : "bg-tribal-border/50 mr-4"
          }`}
        >
          <div className="flex items-center justify-between mb-1">
            <span className="font-medium text-tribal-muted">
              {comm.channel === "note" ? "📝 Staff Note" : comm.channel === "phone" ? `📞 Phone Call${comm.from_address ? ` · ${comm.from_address.split("@")[0]}` : ""}` : comm.direction === "outbound" ? "You" : comm.from_address?.split("@")[0] ?? "Customer"}
              {" "}
              {comm.channel !== "note" && (
                <span className="text-tribal-muted/60">
                  via {comm.channel}
                </span>
              )}
            </span>
            <span className="text-tribal-muted/60">
              {comm.sent_at
                ? new Date(comm.sent_at).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                  })
                : ""}
            </span>
          </div>
          {comm.subject && (
            <div className="font-medium text-white mb-0.5">{comm.subject}</div>
          )}
          <div className="text-tribal-muted whitespace-pre-wrap break-words">
            {stripHtmlForDisplay(comm.body ?? "")}
          </div>
        </div>
      ))}
    </div>
  );
}

function stripHtmlForDisplay(html: string): string {
  return html
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 500);
}
